import React from 'react'
import FlexView from 'react-flexview/lib'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import { CirclesFade } from './CircleFade'

export const MotorcycleEndorsementPopup = ({ isPurple, icon, open, title, body, onConfirm, onCancel, onConfirmButtonText, ...props }) => {
  const handleClose = () => {
    onCancel && onCancel()
  }

  const Confirm = async () => {
    handleClose()
    onConfirm && onConfirm()
  }
  return (
    <SkywatchDialog open={open} closeDialog={handleClose} maxWidth={'xs'} closeTitle={title}>
      <FlexView column>
        <CirclesFade className="absolute left-6 top-22" />
        <div className={`${isPurple ? 'purple-' : 'red-'}large-circle`}>
          <div className={`${isPurple ? 'purple-' : 'red-'}circle`}>{icon}</div>
        </div>
        <div className="popup-title margin-top-basic z-index-1">{title}</div>
        <div className="text-body black margin-top-10 margin-bottom-basic">{body}</div>
        <div className="flex margin-bottom-basic gap-12">
          <button onClick={handleClose} className="white-button bold font-14 width-half position-relative">
            Close
          </button>
          <button onClick={Confirm} className={`${isPurple ? 'purple-' : 'red-'}button font-14 bold width-half`}>
            {onConfirmButtonText}
          </button>
        </div>
      </FlexView>
    </SkywatchDialog>
  )
}
